import axios from "axios";
import React, { Component } from "react";
import apiCall from '../../common/utils/apiCall';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  LogIn,
  Registration,
  ForgotPassword,
  RegisterVerification,
} from "../components/";
import { connect } from "react-redux";
import envVariables from "../../../config";

const {
  REACT_APP_LOGIN_URL,
  REACT_APP_SIGNUP_URL,
  REACT_APP_SEND_OTP_ON_USER_EMAIL,
  REACT_APP_RESET_PASSWORD_URL,
} = envVariables;

class LogInAuthData extends Component {
  state = {
    dataFromRegistration: {},
  };

  logInEventHandle = async (data) => {
    let dataFromRegistration = data;
    try {
      this.setState({ dataFromRegistration });
      if (Object.keys(this.state.dataFromRegistration).length > 0) {
        dataFromRegistration = this.state.dataFromRegistration;
      }
      const {data} = await axios.post(REACT_APP_LOGIN_URL, dataFromRegistration);
      let result = data.result;
      if (result.status && result.success) {
        window.localStorage.setItem("token", result.status.token);
        // <Link to={'/admin/numbers'}/>
        window.location.href = '/admin/numbers'
      } else {
        alert(result.msg);
      }
    } catch (error) {
      toast.error(error.response.data.result.msg);
      // alert(`Expected Error => [${error.response.data.result.msg}]`);
    }
  };

  render() {
    // console.log(this.state.dataFromRegistration);
    return (
      <React.Fragment>
        <LogIn propsToContainer={this.logInEventHandle} />
        <ToastContainer
          position="top-right"
          autoClose={4000}
          hideProgressBar={false}
          newestOnTop
          closeOnClick
          rtl={false}
          pauseOnFocusLoss={false}
          draggable
          pauseOnHover
        />
      </React.Fragment>
    );
  }
}

class RegAuthData extends Component {
  state = {
    dataFromRegistration: {},
    userEmail: {
      email: "",
    },
  };

  registrationEventHandle = async (data, isPleaseWaitLoading) => {
    let dataFromRegistration = data;
    let userEmail = {
      email: dataFromRegistration.email,
    };
    try {
      this.setState({ dataFromRegistration });
      this.setState({ userEmail });
      if (Object.keys(this.state.dataFromRegistration).length > 0) {
        dataFromRegistration = this.state.dataFromRegistration;
        userEmail = this.state.userEmail;
      }
      console.log();
      const {result} = await apiCall('REACT_APP_SIGNUP_URL', 'POST', dataFromRegistration);
      if (result && result.success) {
        toast.success(`[${result.msg}`);
        window.location.assign("/login");
      } else {
        isPleaseWaitLoading(false);
      }
    } catch (error) {
      console.log(error);
      toast.error(`Expected Error => ${error.message}]`);
      isPleaseWaitLoading(false);
      // window.location.reload();
    }
  };

  render() {
    // console.log(this.state.dataFromRegistration);
    return (
      <React.Fragment>
        <Registration propsToContainer={this.registrationEventHandle} />
        <ToastContainer
          position="top-right"
          autoClose={4000}
          hideProgressBar={false}
          newestOnTop
          closeOnClick
          rtl={false}
          pauseOnFocusLoss={false}
          draggable
          pauseOnHover
        />
      </React.Fragment>
    );
  }
}

class ForgotPassAuthData extends Component {
  // state = {
  //   userEmail: {},
  //   forgotPassOTPVerify: '',
  // };
  // forgotPassEventHandle = async(data) => {
  //   let userEmail = data
  //   this.setState({userEmail : userEmail})
  //   if (Object.keys(this.state.userEmail).length > 0) {
  //     userEmail = this.state.userEmail
  //   }
  //   try{
  //     console.log(userEmail);
  //     const { data } = await axios.post(SEND_OTP_ON_USER_EMAIL, userEmail);
  //     if (data.success) {
  //       // alert(`[${data.msg} to given Email]`);
  //       this.setState({forgotPassOTPVerify: data.status.OTP})
  //       window.localStorage.setItem("forgotPassOTPVerify", data.status.OTP);
  //     }
  //   }catch(error){
  //     console.log(error);
  //   }
  // };

  state = {
    userEmail: {},
    isEmailSend: false
  };
  forgotPassEventHandle = async (data) => {
    let userEmail = data;
    try {
      this.setState({ userEmail });
      if (Object.keys(this.state.userEmail).length > 0) {
        userEmail = this.state.userEmail;
      }
      const { data } = await axios.post(REACT_APP_RESET_PASSWORD_URL, userEmail);
      if (data.success) {
        console.log(data.status._id);
        window.localStorage.setItem("isEmailSend", data.success)
        this.setState({isEmailSend : data.success})
      }
    } catch (error) {
      console.log(error.response.data.msg);
      toast.error(error.response.data.msg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
      });
    }
  };

  render() {
    return (
      <React.Fragment>
        <ForgotPassword
          isEmailSend={this.state.isEmailSend}
          propsToContainer={this.forgotPassEventHandle}
        />
        <ToastContainer
          position="top-right"
          autoClose={4000}
          hideProgressBar={false}
          newestOnTop
          closeOnClick
          rtl={false}
          pauseOnFocusLoss={false}
          draggable
          pauseOnHover
        />
      </React.Fragment>
    );
  }
}
class RegisterVerifyAuthData extends Component {
  state = {
    userSignUpData: {},
  };
  registerVerifyEventHandle = async (data) => {
    let userSignUpData = {
      ...data,
      // ...(this.props.state.userSignUpData)
      ...JSON.parse(window.localStorage.getItem("signUp")),
    };
    // window.localStorage.removeItem("signUp");
    this.setState({
      userSignUpData,
    });
    try {
      if (Object.keys(this.state.userSignUpData).length > 0) {
        userSignUpData = this.state.userSignUpData;
      }
      console.log(userSignUpData);
      const { data } = await axios.post(REACT_APP_SIGNUP_URL, userSignUpData);
      if (data.success) {
        window.sessionStorage.removeItem("OTPToVerify");
        window.localStorage.removeItem("signUp");
        window.location.assign("/login");
      }else{
        window.localStorage.removeItem("signUp");
      }
    } catch (error) {
      console.log(error.response);
      alert(
        `Expected Error => [${error.response.data.err.list.password.message}]`
      );
    }
  };
  render() {
    console.log(this.state.userSignUpData);
    return (
      <React.Fragment>
        <RegisterVerification
          propsToContainer={this.registerVerifyEventHandle}
        />
      </React.Fragment>
    );
  }
}

export {
  LogInAuthData,
  RegAuthData,
  ForgotPassAuthData,
  RegisterVerifyAuthData,
};

const mapStateToProps = (state) => {
  return { state }
}

connect(mapStateToProps)(RegisterVerifyAuthData)